import React from "react";
import Navbar from "../components/Nav";
import WelcomeSection from "../components/WelcomeSection";
import WtfIsThis from "../components/WtfIsThis";
import HowToUse from "../components/HowToUse";
import AdSec from "../components/AdSec";


const Home = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex flex-col h-screen">
        <WelcomeSection />
      </div>
      <div className="flex flex-col md:flex-row ">
        <div className="w-full md:w-1/2 h-0.7 md:h-full ">
          <WtfIsThis />
        </div>
        <div className="w-full md:w-1/2 h-0.7 md:h-full bg-red-600 ">
          <HowToUse />
        </div>
      </div>
      <div className="flex flex-col h-screen">
        <AdSec />
      </div>
    </div>
  );
};

export default Home;
